import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '../../../../../styles'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import selectColorEnum from '../../../../../enums/selectEnums/SelectColorEnum'
import selectSizeEnum from '../../../../../enums/selectEnums/SelectSizeEnum'
import { MenuItem } from '@material-ui/core'
import SelectField from '../../../../../components/fields/SelectField'
import AccountList from './AccountList'
import { Releve } from '../account_model'
import { ContractsModel } from '../../../../../types/contracts/contractsModel'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		selectDiv: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		},
		textNotSelected: {
			color: theme.palette.blue['50']
		},
		accountBodyContainer: {
			padding: '41px 56px'
		},
		smallAccountBodyContainer: {
			padding: '20px 16px'
		}
	}
))

interface AcceptingProps {
	releves: Array<Releve>,
	listYear: Array<number>,
	selectedYear: number,
	setSelectedYear: React.Dispatch<React.SetStateAction<number>>,
	isLargeScreen: boolean,
	setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
	contract: ContractsModel,
	paymentDisabled: boolean
}

type AccountBodyProps = AcceptingProps

const AccountBody: React.FC<AccountBodyProps> = (
	{
		releves,
		listYear,
		selectedYear,
		setSelectedYear,
		isLargeScreen,
		setOpenPayment,
		contract,
		paymentDisabled
	}
) => {
	const classes = useStyle()

	const titleDetails = classNames(
		classes.colorBlue,
		isLargeScreen ? classes.title3 : classes.text19
	)
	const inputText = classNames(
		isLargeScreen ? classes.text8 : classes.text14,
		classes.colorBlue,
		classes.semiBold
	)
	const textSelect = classNames(
		classes.text8,
		classes.textNotSelected
	)

	//Set state year to selected year value
	const handleChangeYear = (event: React.ChangeEvent<{ value: unknown }>) => {
		setSelectedYear(event.target.value as number)
	}

	//Sort operations by date
	const sortOperation = (releves : Releve[]) =>{
		return releves.sort((a, b) => b.operation_date.getTime() - a.operation_date.getTime())
	}

	return (
		<div className={isLargeScreen ? classes.accountBodyContainer : classes.smallAccountBodyContainer}>
			<div className={classes.selectDiv}>
				<span className={titleDetails}>
					<FormattedMessage
						id="contracts.account.accountDetails"
						defaultMessage="Votre relevé de compte"
						description="Account Details"
					/>
				</span>
				<SelectField
					value={selectedYear}
					inputTextStyle={inputText}
					onChange={handleChangeYear}
					backgroundColor={selectColorEnum.grey}
					size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
				>
					{
						listYear.map((year: number) =>
							<MenuItem
								key={year}
								value={year}
								className={textSelect}
							>
								{year}
							</MenuItem>
						)
					}
				</SelectField>
			</div>
			<AccountList
				paymentDisabled={paymentDisabled}
				contract={contract}
				releves={sortOperation(releves)}
				isLargeScreen={isLargeScreen}
				setOpenPayment={setOpenPayment}
			/>
		</div>
	)
}

export default AccountBody
